//============================================================================
// Name        : catalog_sidebar.ts
// Purpose     : Implement catalog page sidebar logic
// Created     : 2020-01-28
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import * as QueryString from "query-string";
import {SeTreeview} from "../controls/se_treeview";
import {InitPage} from "../index";

declare var loadCategoriesUrl: string;
declare var inventoryCountCategories: string;

export function LoadPage() {
    InitPage("items index", () => {


    });
}
